// Where the API lives, per environment.
//
// Deliberately free of any Apollo import. `createHttpLink` runs at module scope
// in ./http-link and throws when there is no global fetch (jsdom), so anything
// that only needs the base URI, the QR redirect, the public training-exam
// routes, must import it from here rather than pulling the whole link chain in.
let link = {}

if (process.env.VUE_APP_DEV_ENV === 'staging') {
  link['bowvue_base_uri'] = 'https://api.staging.bowvue.com'
  link['uri'] = link['bowvue_base_uri'] + '/graphql'
} else if (process.env.NODE_ENV === 'production') {
  link['bowvue_base_uri'] = 'https://api.bowvue.com'
  link['uri'] = link['bowvue_base_uri'] + '/graphql'
} else {
  link['bowvue_base_uri'] = 'http://localhost:8888'
  link['uri'] = link['bowvue_base_uri'] + '/query'
}

export { link }
